import { getApiUrl, getAxiosInstanceByLoginMode } from './shared';

const getEmployeeRoutes = () => {
  return getAxiosInstanceByLoginMode().get(`${getApiUrl()}/employees/me/routes`);
};

export { getEmployeeRoutes };
